"use strict";

exports.__esModule = true;
exports.getLinkTitle = exports.getLinkIconUrl = exports._urlSplicing = void 0;

var _urlSplicing = function _urlSplicing(uri, prefix, suffix) {
  var exclude = ["http://", "https://", "Custom-App://", "file://"];

  for (var i = 0; i < exclude.length; i++) {
    var row = exclude[i];

    if (uri.indexOf(row) === 0) {
      return uri;
    }
  }

  if (window.baseUrl) {
    return "" + window.baseUrl + uri;
  }

  return "" + prefix + uri;
};

exports._urlSplicing = _urlSplicing;

var getLinkIconUrl = function getLinkIconUrl(data, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing) {
  if (urlSplicing === void 0) {
    urlSplicing = _urlSplicing;
  }

  var iconUrl = data.iconMediaUrl;

  if (iconUrl && iconUrl !== "") {
    var DOMAIN = data.iconMediaId === 0 ? PUBLIC_DOMAIN : MEDIA_DOMAIN;
    return {
      src: urlSplicing(iconUrl, DOMAIN, 160)
    };
  }

  if (data.type === 0) {
    return {
      position: -320
    };
  }

  switch (data.children[0].code) {
    case 0:
      return {
        position: -400
      };

    case 1:
      return {
        position: -80
      };

    case 2:
      return {
        position: -40
      };

    case 3:
      return {
        position: -280
      };

    case 4:
      return {
        position: -160
      };

    case 5:
      return {
        position: -240
      };

    case 6:
      return {
        position: -200
      };

    case 7:
      return {
        position: -360
      };

    case 8:
      return {
        position: -120
      };

    case 9:
      return {
        position: 0
      };

    case 11:
      return {
        position: -720
      };

    case 12:
      return {
        position: -800
      };

    default:
      return null;
  }
};

exports.getLinkIconUrl = getLinkIconUrl;

var getLinkTitle = function getLinkTitle(data, language, shwoDefaultTitle) {
  if (shwoDefaultTitle === void 0) {
    shwoDefaultTitle = true;
  }

  var title = data.title;

  if (title && title !== "") {
    return title;
  }

  var groupTitle = data.groupTitle;

  if (groupTitle && groupTitle !== "") {
    return groupTitle;
  }

  if (!shwoDefaultTitle) return "";

  switch (data.code) {
    case 0:
      return language === 2 ? "Link" : "超链接";

    case 1:
      return language === 2 ? "Hotline" : "联系电话";

    case 2:
      return language === 2 ? "Location" : "地图导航";

    case 3:
      return language === 2 ? "Photo" : "查看图文";

    case 4:
      return language === 2 ? "Text" : "查看文本";

    case 5:
      return language === 2 ? "Article" : "查看文章";

    case 6:
      return language === 2 ? "Audio" : "查看音频";

    case 7:
      return language === 2 ? "Video" : "查看视频";

    case 8:
      return language === 2 ? "Object VR" : "查看环物";

    case 9:
      return language === 2 ? "Return" : "返回";

    case 11:
      return language === 2 ? "Event" : "事件";

    case 12:
      return language === 2 ? "Mini Program" : "小程序";

    case 13:
      return language === 2 ? "PDF" : "查看PDF";

    case 14:
      return language === 2 ? "3D Model" : "3D模型";

    case 15:
      return language === 2 ? "Previous" : "上一场景";

    case 16:
      return language === 2 ? "Next" : "下一场景";

    default:
      return language === 2 ? "Group" : "分组";
  }
};

exports.getLinkTitle = getLinkTitle;